module.exports = __webpack_public_path__ + "8d7e0c569f553eeb5dcbc98a5811a811.png";